import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/lotuss-coin.png'


const _withScopeId = n => (_pushScopeId("data-v-240d0194"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coin-history-header-section" }
const _hoisted_2 = { class: "point" }
const _hoisted_3 = { class: "point-content" }
const _hoisted_4 = {
  key: 0,
  class: "clubcard-card-content-coin",
  src: _imports_0
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "coupon" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 2,
  class: "arrow"
}

export function render(_ctx, _cache) {
  const _component_q_skeleton = _resolveComponent("q-skeleton")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['coin-history-header', { 'header-skeleton': _ctx.isLoadingPoints }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(['label-point', { 'label-point-skeleton': _ctx.isLoadingPoints }])
          }, [
            (!_ctx.isLoadingPoints)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.isLoadingPoints)
              ? (_openBlock(), _createBlock(_component_q_skeleton, {
                  key: 1,
                  class: "clubcard-card-content-coin skeleton-circle",
                  width: "24px",
                  height: "24px"
                }))
              : _createCommentVNode("", true),
            (!_ctx.isLoadingPoints)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.getLabelPoints()), 1))
              : _createCommentVNode("", true),
            (_ctx.isLoadingPoints)
              ? (_openBlock(), _createBlock(_component_q_skeleton, {
                  key: 3,
                  class: "skeleton",
                  width: "114px",
                  height: "24px"
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.isLoadingPoints)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.openModalCouponBZB())),
                  class: "btn"
                }, "แลกรีวอร์ด"))
              : _createCommentVNode("", true),
            (_ctx.isLoadingPoints)
              ? (_openBlock(), _createBlock(_component_q_skeleton, {
                  key: 1,
                  class: "skeleton-type-btn",
                  width: "91px",
                  height: "28px"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.points !== 0 && _ctx.tieredPoints?.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "label-tiered-point",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.onShowModalTieredPoints()))
            }, [
              (!_ctx.isLoadingPoints)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.getLabelTieredPoints()), 1))
                : _createCommentVNode("", true),
              (_ctx.isLoadingPoints)
                ? (_openBlock(), _createBlock(_component_q_skeleton, {
                    key: 1,
                    class: "skeleton",
                    width: "203px",
                    height: "16px"
                  }))
                : _createCommentVNode("", true),
              (!_ctx.isLoadingPoints)
                ? (_openBlock(), _createElementBlock("button", _hoisted_8, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}